// Simple SEO utility functions
export const updatePageSEO = (title, description, keywords) => {
  // Update page title
  document.title = title;

  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }

  // Update meta keywords
  const metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords && keywords) {
    metaKeywords.setAttribute('content', keywords);
  }
};

export const addStructuredData = (data) => {
  // Remove existing structured data script if present
  const existingScript = document.querySelector('script[data-seo="page-structured-data"]');
  if (existingScript) {
    existingScript.remove();
  }

  // Add new structured data
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute('data-seo', 'page-structured-data');
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
};

// SEO data for different pages
export const seoData = {
  home: {
    title: 'MEGATON - Locação de Munck e Guindaste em Rondonópolis | Munck Roo',
    description:
      'Locação de munck e guindaste em Rondonópolis e região. Munck Roo, Guindaste Roo. Serviços profissionais de içamento, transporte e movimentação de cargas.',
    keywords:
      'munck rondonopolis, guindaste rondonopolis, munck roo, guindaste roo, locação munck, locação guindaste, içamento rondonópolis, transporte pesado',
  },
  equipment: {
    title: 'Equipamentos - Munck e Guindaste | MEGATON Rondonópolis',
    description:
      'Conheça nossa frota de muncks e guindastes em Rondonópolis. Munck Convencional, Munck Especial E8, Munck FLYJIB, Guindastes 70 e 90 toneladas.',
    keywords:
      'munck convencional, munck especial, guindaste 70 toneladas, guindaste 90 toneladas, frota munck, equipamentos içamento',
  },
  company: {
    title: 'Quem Somos - MEGATON | Empresa de Munck e Guindaste Rondonópolis',
    description:
      'Conheça a MEGATON, empresa especializada em locação de munck e guindaste em Rondonópolis. Experiência, segurança e qualidade nos serviços de içamento.',
    keywords:
      'empresa munck, empresa guindaste, megaton rondonopolis, história empresa, equipe qualificada, segurança içamento',
  },
  contact: {
    title: 'Contato - MEGATON | Locação Munck e Guindaste Rondonópolis',
    description:
      'Entre em contato com a MEGATON para locação de munck e guindaste em Rondonópolis. Orçamento sem compromisso. Telefone: (66) 99923-0430.',
    keywords:
      'contato munck, contato guindaste, orçamento munck, orçamento guindaste, telefone munck rondonópolis',
  },
  photos: {
    title: 'Portfólio de Serviços - MEGATON | Fotos Munck e Guindaste',
    description:
      'Veja nossos trabalhos realizados com munck e guindaste em Rondonópolis. Galeria de fotos dos serviços de içamento e transporte executados.',
    keywords:
      'fotos munck, fotos guindaste, portfólio serviços, trabalhos realizados, galeria munck guindaste',
  },
};

// SEO data for individual equipment pages
export const equipmentSeoData = {
  'munck-convencional': {
    title: 'Munck Convencional 45 ton.metro - Locação MEGATON Rondonópolis',
    description:
      'Locação de Munck Convencional 45 ton.metro em Rondonópolis. 4 lanças hidráulicas, capacidade 11 ton a 4,2m, alcance 12 metros. Munck Roo.',
    keywords:
      'munck convencional, munck 45 toneladas, locação munck rondonópolis, munck 4 lanças hidráulicas',
  },
  'munck-especial-e8': {
    title: 'Munck Especial E8 46 ton.metro - Locação MEGATON Rondonópolis',
    description:
      'Locação de Munck Especial E8 46 ton.metro em Rondonópolis. 8 lanças hidráulicas, capacidade 9 ton a 4,5m, alcance 20 metros. Munck Roo.',
    keywords:
      'munck especial e8, munck 8 lanças, munck 46 toneladas, locação munck especial rondonópolis',
  },
  'munck-especial-flyjib': {
    title: 'Munck Especial FLYJIB 62 ton.metro - Locação MEGATON Rondonópolis',
    description:
      'Locação de Munck Especial FLYJIB 62 ton.metro em Rondonópolis. 5 lanças + FLYJIB 4 hidráulicas, capacidade 12 ton a 4,2m, alcance 31 metros.',
    keywords: 'munck flyjib, munck especial flyjib, munck 62 toneladas, munck alcance 31 metros',
  },
  'guindaste-70-toneladas': {
    title: 'Guindaste 70 Toneladas TEREX LT1070 - Locação MEGATON',
    description:
      'Locação de Guindaste 70 toneladas TEREX LT1070 em Rondonópolis. 59 metros de lança, ideal para construção civil e projetos industriais.',
    keywords:
      'guindaste 70 toneladas, terex lt1070, guindaste 59 metros, locação guindaste rondonópolis',
  },
  'guindaste-90-toneladas-zoomlion': {
    title: 'Guindaste 90 Toneladas ZOOMLION ZMC900V5 - Locação MEGATON',
    description:
      'Locação de Guindaste 90 toneladas ZOOMLION ZMC900V5 em Rondonópolis. 65 metros de lança, alta capacidade para projetos complexos.',
    keywords:
      'guindaste 90 toneladas, zoomlion zmc900v5, guindaste 65 metros, locação guindaste industrial',
  },
  'guindaste-90-toneladas-sany': {
    title: 'Guindaste 90 Toneladas SANY STC900T5 - Locação MEGATON',
    description:
      'Locação de Guindaste 90 toneladas SANY STC900T5 em Rondonópolis. 76,5 metros de lança, máxima capacidade e alcance para grandes projetos.',
    keywords:
      'guindaste 90 toneladas, sany stc900t5, guindaste 76 metros, locação guindaste grande porte',
  },
};

// Function to add breadcrumb schema
export const addBreadcrumbSchema = (breadcrumbs) => {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: crumb.url,
    })),
  };
  addStructuredData(breadcrumbSchema);
};

// Function to add FAQ schema
export const addFaqSchema = (faqs) => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
  addStructuredData(faqSchema);
};

// Function to update Open Graph tags
export const updateOpenGraphTags = (ogData) => {
  const tags = {
    'og:title': 'title',
    'og:description': 'description',
    'og:image': 'image',
    'og:url': 'url',
    'og:type': 'type',
  };

  Object.entries(tags).forEach(([property, value]) => {
    if (ogData[value]) {
      const metaTag = document.querySelector(`meta[property="${property}"]`);
      if (metaTag) {
        metaTag.setAttribute('content', ogData[value]);
      } else {
        const newTag = document.createElement('meta');
        newTag.setAttribute('property', property);
        newTag.setAttribute('content', ogData[value]);
        document.head.appendChild(newTag);
      }
    }
  });
};

// Function to add canonical URL
export const setCanonicalURL = (url) => {
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute('href', url);
  } else {
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = url;
    document.head.appendChild(link);
  }
};

// Function to add hreflang tags
export const addAlternateLanguageTag = (language, url) => {
  const hreflang = document.querySelector(`link[hreflang="${language}"]`);
  if (hreflang) {
    hreflang.setAttribute('href', url);
  } else {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = language;
    link.href = url;
    document.head.appendChild(link);
  }
};

// Function to add Product schema (for equipment pages)
export const addProductSchema = (product) => {
  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.name,
    description: product.description,
    image: product.image,
    brand: {
      '@type': 'Brand',
      name: 'MEGATON',
    },
    offers: {
      '@type': 'Offer',
      price: 'Consultar',
      priceCurrency: 'BRL',
      availability: 'https://schema.org/InStock',
      url: product.url,
    },
  };
  addStructuredData(productSchema);
};

// Function to add Article schema (for blog posts)
export const addArticleSchema = (article) => {
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    image: article.image,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    author: {
      '@type': 'Organization',
      name: 'MEGATON',
    },
    publisher: {
      '@type': 'Organization',
      name: 'MEGATON',
      logo: {
        '@type': 'ImageObject',
        url: 'https://megatonguindastes.com.br/images/logo/megaton-logo.png',
      },
    },
  };
  addStructuredData(articleSchema);
};

// Function to add rich snippet for rating/review
export const addReviewSchema = (review) => {
  const reviewSchema = {
    '@context': 'https://schema.org',
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: review.rating,
      bestRating: '5',
      worstRating: '1',
    },
    reviewBody: review.text,
    author: {
      '@type': 'Person',
      name: review.author,
    },
    datePublished: review.date,
  };
  addStructuredData(reviewSchema);
};

// Function to generate metadata for local SEO
export const generateLocalSeoMetadata = (business) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: business.name,
    image: business.image,
    description: business.description,
    telephone: business.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: business.address.street,
      addressLocality: business.address.city,
      addressRegion: business.address.state,
      postalCode: business.address.zipCode,
      addressCountry: business.address.country,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: business.geo.latitude,
      longitude: business.geo.longitude,
    },
    url: business.website,
    openingHoursSpecification: business.hours.map((hour) => ({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: hour.day,
      opens: hour.opens,
      closes: hour.closes,
    })),
    sameAs: business.socialProfiles || [],
  };
};

// Função para monitorar Core Web Vitals e performance
export const logWebVitals = () => {
  if ('web-vital' in window && typeof window.reportWebVitals === 'function') {
    window.reportWebVitals((metric) => {});
  }
};

// Function to add JSON-LD for Service
export const addServiceSchema = (service) => {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: service.name,
    description: service.description,
    serviceType: service.type,
    areaServed: service.areaServed,
    provider: {
      '@type': 'LocalBusiness',
      name: 'MEGATON',
      url: 'https://megatonguindastes.com.br',
    },
    offers: {
      '@type': 'Offer',
      priceCurrency: 'BRL',
      price: 'Consultar',
    },
  };
  addStructuredData(serviceSchema);
};
